const DEFAULT_LANGUAGE = "en";

const supportedLanguages = {
  "en": "English",
  "de": "Deutsch",
  "es": "Español",
  "fa": "فارسی",
  "fr": "Français",
  "hi": "हिंदी",
  "id": "Bahasa",
  "it": "Italiano",
  "ja": "日本語",
  "ko": "한국어",
  "nl": "Nederlands",
  "th": "ภาษาไทย",
  "zh": "简体中文",
  "zh-TW": "繁體中文",
  "vi": "Tiếng Việt"
};

const supportedLanguagesPrimaryKeys = new Set(
  Object.keys(supportedLanguages).map(code => code.split("-")[0])
);

const traditionalChineseSubtags = new Set(["tw", "hk", "mo", "hant"]);

const queriedLanguage = new URLSearchParams(window.location.search).get("language");

function isValidLanguage(langKey) {
  return Object.hasOwn(supportedLanguages, langKey);
}

function findSupportedLanguage(inputLanguage) {
  if (!inputLanguage) return DEFAULT_LANGUAGE;

  const subtags = inputLanguage.toLowerCase().split(/[-_]/);
  // "cn" is a non-standard code sometimes used for Simplified Chinese
  const primaryLang = subtags[0] === "cn" ? "zh" : subtags[0];

  if (!supportedLanguagesPrimaryKeys.has(primaryLang)) return DEFAULT_LANGUAGE;

  if (primaryLang === "zh") {
    // Traditional Chinese variants: TW, HK, MO regions or Hant script
    return subtags.some(s => traditionalChineseSubtags.has(s)) ? "zh-TW" : "zh";
  }

  return primaryLang;
}

export const initialLanguage = findSupportedLanguage(queriedLanguage || navigator.language);

export function resolveLocale(brandingForcedLanguage) {
  if (queriedLanguage && isValidLanguage(queriedLanguage)) return queriedLanguage;
  if (brandingForcedLanguage && isValidLanguage(brandingForcedLanguage)) return brandingForcedLanguage;
  return initialLanguage;
}

export default supportedLanguages;